import React from 'react';
import { Button } from 'rsuite';
import { ModalsService } from '../../../services/modals.service';
import { ConfirmModal } from '../../common/confirm-modal';

import { trpc, RouterInput } from '../../../api/trpc';
import { AlertService } from '../../../services/alert.service';
import { useNavigate } from 'react-router-dom';
import useSWRMutation from 'swr/mutation';

type Props = {
  id: string;
};
export const RetailDeliveryBulkButton: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const { trigger: deleteOrder, isMutating: deleteOrderIsMutating } =
    useSWRMutation(
      ['retailDelivery.requestAdmin.deleteOrder'],
      (
        _k,
        {
          arg,
        }: {
          arg: RouterInput['retailDelivery']['requestAdmin']['deleteOrder'];
        },
      ) => trpc.retailDelivery.requestAdmin.deleteOrder.mutate(arg),
    );

  return (
    <Button
      className={'btn btn-outline-danger '}
      onClick={async () => {
        await ModalsService.createModal(ConfirmModal, {
          title: 'Вы действительно хотите удалить экспресс-доставку?',
          buttonText: 'Удалить экспресс\u00A0\u2011\u00A0доставку',
        })
          .then(() => {
            return deleteOrder({ orderId: props.id });
          })
          .then(() => {
            navigate('/deliveries/orders/retail');
          })
          .then(() => {
            AlertService.success('Экспресс-доставка успешно удалена');
          });
      }}
      disabled={deleteOrderIsMutating}
    >
      ОПТ
    </Button>
  );
};
